module.exports = __webpack_public_path__ + "img/dislike.3a11a792.svg";